
import periods from "./Periods.js"
export default {
  id : 3,
  title : "OPEX UG Mining Development",
  template : "pageA",
  i18n : "ABC.Development.Title",
  link: "/abc/kpi/opex/ugmining/development",
  layout : {
    upper1 : {
      name : "OPEX",
      type : "radialBar",
      i18n : "ABC.OPEX.BaseValue",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopment",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      },
      zoomIn : {
        name : "OPEX Periodic",
        i18n : "ABC.Development.Title",
        type : "comparaisonLine",
        url: "/Hyperion/Kpi/PeriodicOPEXUGMiningDevelopment",
        chartData : {
          categories : periods,
          leftDataTitle: "Actual",
          leftDataTitlei18n: "Actual",
          rightDataTitle: "Budget",
          rightDataTitlei18n: "Budget",
          dataFilter: "KPI_M_k_formatter"
        }
      }
    },
    upper2 : {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentPerOz",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "k_formatter"
      },
      zoomIn : {
        name : "Gold production",
        i18n : "ABC.GoldProduction.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/GoldProduction",
        chartData : {
          categories : ["Au"],
          yAxisTitle: "Production (Oz)"
        }
      }
    },
    upper3 : {
      name : "OPEX Per Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentPerTonOre",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      },
      zoomIn : {
        name : "Ore Tonnes",
        i18n : "ABC.OreTons.Title",
        type : "basicColumn",
        url: "/Hyperion/Kpi/OreTons",
        chartData : {
          categories : ["Ore"],
          yAxisTitle: "Ore (Tons)"
        }
      }
    },
    middle1 : {
      name : "OPEX Per Oz",
      i18n : "ABC.OPEX.OPEXPerOz",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXUGMiningDevelopmentPerOz",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    middle2: {
      name : "OPEX Ton Ore",
      i18n : "ABC.OPEX.OPEXPerTonOre",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXUGMiningDevelopmentPerTonOre",
      chartData : {
        categories : periods,
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      }
    },
    below1 : {
      name : "OPEX Mining Development",
      type : "radialBar",
      i18n : "ABC.Drilling",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentDrilling",
      drillTo: "/abc/kpi/opex/ugmining/development/drilling",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below2 : {
      name : "OPEX Mining Production",
      type : "radialBar",
      i18n : "ABC.Blasting",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentBlasting",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below3 : {
      name : "OPEX Mining Services",
      type : "radialBar",
      i18n : "ABC.Mucking",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentMucking",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    },
    below4 : {
      name : "OPEX Mining Maintenance'",
      type : "radialBar",
      i18n : "ABC.Hauling",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentHauling",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      }
    }
  }
}
  
